<div class="date-range-dialog">
  <div class="dialog-header">
    <h1 class="dialog-title">{{ dialogTitle | translate }}</h1>
    <button mat-icon-button mat-dialog-close>
      <gb-icon [icon]="'close'"></gb-icon>
    </button>
  </div>
  <form [formGroup]="formDateRange" (submit)="onSubmit()">
    <div>
      <p class="instructions" translate="STAFF.DATE_PICKER_DIALOG_TEXT"></p>
      <div class="input-container">
        <mat-form-field>
          <mat-label translate="STAFF.DATE_PICKER_RANGE"></mat-label>
          <mat-date-range-input [rangePicker]="rangePicker" [max]="today">
            <input
              matStartDate
              [formControl]="startDate"
              placeholder="{{ 'STAFF.DATE_PICKER_START_DATE' | translate }}"
            />
            <input matEndDate [formControl]="endDate" placeholder="{{ 'STAFF.DATE_PICKER_END_DATE' | translate }}" />
          </mat-date-range-input>
          <mat-hint>MMM DD, YYYY – MMM DD, YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker [touchUi]="isMobileOrTabletDevice$ | async">
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel translate="GENERIC.CANCEL"></button>
              <button mat-raised-button matDateRangePickerApply translate="GENERIC.APPLY"></button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
          @if (isStartDateRequired()) {
            <mat-error translate="FORMS.ERROR.START_DATE_REQUIRED"></mat-error>
          }
          @if (isEndDateRequired()) {
            <mat-error translate="FORMS.ERROR.END_DATE_REQUIRED"></mat-error>
          }
          @if (startDate.hasError('matDatepickerParse')) {
            <mat-error translate="FORMS.ERROR.INVALID_START_DATE"></mat-error>
          }
          @if (endDate.hasError('matDatepickerParse')) {
            <mat-error translate="FORMS.ERROR.INVALID_END_DATE"></mat-error>
          }
          @if (startDate.hasError('matDatepickerMax') || endDate.hasError('matDatepickerMax')) {
            <mat-error translate="FORMS.ERROR.INVALID_FUTURE_DATE"></mat-error>
          }
          @if (endDate.hasError('dateAfter')) {
            <mat-error>
              {{ endDate.errors?.dateAfter?.message | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <button mat-flat-button type="submit" [disabled]="(exportReportLoaded$ | async) === false">
      <gb-button-loader [loaded$]="exportReportLoaded$">
        <span>{{ 'STAFF.DATE_PICKER_DOWNLOAD_TEXT' | translate }}</span>
      </gb-button-loader>
    </button>
  </form>
</div>
